import React from 'react';
import { View, Text } from 'react-native';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react-native';
import { useThemeColors } from '@/lib/useThemeColors';

interface TrendChipProps {
  current: number;
  previous?: number;
  unit?: 'week' | 'month';
  hidePeriodLabel?: boolean;
}

export function TrendChip({ current, previous, unit = 'week', hidePeriodLabel = false }: TrendChipProps) {
  const colors = useThemeColors();

  if (previous === undefined || previous === null) return null;

  const delta = current - previous;
  const isFlat = delta === 0;
  const isUp = delta > 0;

  const tint = isFlat ? colors.text.tertiary : isUp ? colors.success : colors.error;
  const bg = isFlat
    ? colors.surface.secondary
    : isUp
      ? colors.traffic.greenLight
      : colors.red.light;

  const Icon = isFlat ? Minus : isUp ? TrendingUp : TrendingDown;
  const sign = isUp ? '+' : '';
  const periodLabel = unit === 'week' ? 'this week' : 'this month';

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 4,
          backgroundColor: bg,
          paddingHorizontal: 8,
          paddingVertical: 4,
          borderRadius: 8,
        }}
      >
        <Icon size={12} color={tint} />
        <Text style={{ color: tint, fontSize: 11, fontWeight: '700' }} numberOfLines={1}>
          {isFlat ? '0' : `${sign}${delta}`}
        </Text>
      </View>
      {!hidePeriodLabel && (
        <Text style={{ color: colors.text.tertiary, fontSize: 11 }} numberOfLines={1}>
          {periodLabel}
        </Text>
      )}
    </View>
  );
}
